import { Box, useMediaQuery } from "@mui/material";
import { useState } from "react";
import AdminHeader from "./AdminHeader";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import theme from "../../theme/Theme";
import styles from "./styles";

const AdminLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AdminHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />
            <Box sx={styles.adminLayoutContainer}>
                <Box sx={styles.adminAside}>
                    <AdminSidebar
                        isMobile={isMobile}
                        isOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                </Box>
                <Box sx={styles.adminMainContent} component="main">
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default AdminLayout;
